module.exports = __webpack_public_path__ + "img/image-2.8f0ede15.webp";